(() => {
  if (window.__nuvialleFreeGift) return;
  window.__nuvialleFreeGift = true;

  const config = document.getElementById('NuvialleFreeGift');
  const giftId = Number(config && config.dataset.variant);
  const threshold = Number(config && config.dataset.threshold);
  if (!giftId || !threshold) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false;
  let queued = false;

  /* Re-render the header bubble and cart drawer in place (without opening the drawer). */
  const refreshCartUI = async (itemCount) => {
    /* The Nuvialle cart re-renders the drawer, header count and cart page in place. */
    if (window.NuvialleCart && typeof window.NuvialleCart.refresh === 'function') {
      try {
        await window.NuvialleCart.refresh();
      } catch (err) {
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      }
      document.dispatchEvent(new CustomEvent('nuvialle:free-gift-updated'));
      return;
    }
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    try {
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await res.json();
      const inner = (html, selector) => {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        return el ? el.innerHTML : null;
      };
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const html = inner(sections['cart-icon-bubble'], '.shopify-section');
        if (html != null) bubble.innerHTML = html;
      }
      const drawer = document.querySelector('cart-drawer');
      const drawerInner = document.getElementById('CartDrawer');
      if (drawer && drawerInner && sections['cart-drawer']) {
        const html = inner(sections['cart-drawer'], '#CartDrawer');
        if (html != null) {
          drawerInner.innerHTML = html;
          drawer.classList.toggle('is-empty', itemCount === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    } catch (err) {
      /* the next cart change will try again */
    }
    document.dispatchEvent(new CustomEvent('nuvialle:free-gift-updated'));
  };

  const check = async () => {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;
    try {
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const giftLines = cart.items.filter((item) => item.variant_id === giftId);
      // Spend on everything except the gift, after product discounts — the safe side of the checkout rule.
      const spend = cart.items.filter((item) => item.variant_id !== giftId).reduce((sum, item) => sum + item.final_line_price, 0);
      let updates = null;
      let add = false;

      if (spend >= threshold) {
        if (!giftLines.length) add = true;
        else if (giftLines.length > 1 || giftLines[0].quantity !== 1) {
          updates = {};
          giftLines.forEach((line, i) => { updates[line.key] = i === 0 ? 1 : 0; });
        }
      } else if (giftLines.length) {
        updates = {};
        giftLines.forEach((line) => { updates[line.key] = 0; });
      }

      if (add) {
        await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ items: [{ id: giftId, quantity: 1, properties: { _free_gift: 'true' } }] }),
        });
      } else if (updates) {
        await fetch(`${root}cart/update.js`, { method: 'POST', headers, body: JSON.stringify({ updates }) });
      }

      if (add || updates) {
        const after = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        await refreshCartUI(after.item_count);
      }
    } catch (err) {
      /* network hiccup — ignore, the next cart change re-checks */
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        check();
      }
    }
  };

  const soon = () => setTimeout(check, 60);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon);
  else soon();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, soon);
  }
  document.addEventListener('nuvialle:item-added', soon);
})();
